import React from "react";
import DMS_1997 from "../services/PasswordQualityService";

const PasswordStrengthMeter = props => {
	const createPasswordLabel = score => {
		switch (score) {
			case 0:
				return "Weak";
			case 1:
				return "Weak";
			case 2:
				return "Fair";
			case 3:
				return "Good";
			case 4:
				return "Strong";
			default:
				return "Weak";
		}
	};

	const minLength = DMS_1997.minLength;

	const passwordLabel = createPasswordLabel(props.score);

	return (
		<>
			<div className="password-strength-meter">
				<div
					data-testid="strength_meter"
					className={`${props.password.length >= minLength ? "password-strength-meter__progress" : ""} ${props.password.length >= minLength ? "strength-" + passwordLabel : ""}`}
					value={props.score}
				></div>
			</div>
			{props.password.length >= minLength && (
				<p
					data-testid="strength_word"
					className={`password-strength-meter-label ${props.password.length >= minLength ? passwordLabel : ""} ${props.passwordsMatch && props.score >= 2 ? "match-color" : ""}`}
				>
					{passwordLabel}
				</p>
			)}
		</>
	);
};

export default PasswordStrengthMeter;
